import React from "react";

function Footer() {
  const iconStyle = {
    color: "#FF7A00",
    fontSize: "1.2rem", // más pequeño
    marginLeft: "8px",
    verticalAlign: "middle"
  };

  return (
    <footer style={{ backgroundColor: "#2C2C2C", color: "#FFFFFF" }} className="text-center py-3">
      <p style={{ margin: 0, fontSize: "0.9rem" }}>
        &copy; 2025 Turnora. Todos los derechos reservados.
        {/* <a
          href="https://www.instagram.com/tuusuario" // reemplaza con tu link real
          target="_blank"
          rel="noopener noreferrer"
          style={iconStyle}
          aria-label="Instagram"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="currentColor"
            viewBox="0 0 16 16"
          >
            <path d="M8 0C5.743 0 5.5.002 4.675.035 3.855.067 3.236.198 2.706.42c-.53.223-.986.523-1.44.977-.454.454-.754.91-.977 1.44-.222.53-.353 1.15-.385 1.97C0 5.5 0 5.743 0 8s.002 2.5.035 3.325c.032.82.163 1.44.385 1.97.223.53.523.986.977 1.44.454.454.91.754 1.44.977.53.222 1.15.353 1.97.385C5.5 16 5.743 16 8 16s2.5-.002 3.325-.035c.82-.032 1.44-.163 1.97-.385.53-.223.986-.523 1.44-.977.454-.454.754-.91.977-1.44.222-.53.353-1.15.385-1.97.033-.825.035-1.068.035-3.325s-.002-2.5-.035-3.325c-.032-.82-.163-1.44-.385-1.97-.223-.53-.523-.986-.977-1.44-.454-.454-.91-.754-1.44-.977-.53-.222-1.15-.353-1.97-.385C10.5 0 10.257 0 8 0zm0 1.44c2.213 0 2.473.008 3.345.048.793.037 1.224.167 1.51.28.377.146.645.322.927.604.282.282.458.55.604.927.113.286.243.717.28 1.51.04.872.048 1.132.048 3.345s-.008 2.473-.048 3.345c-.037.793-.167 1.224-.28 1.51a2.518 2.518 0 0 1-.604.927 2.518 2.518 0 0 1-.927.604c-.286.113-.717.243-1.51.28-.872.04-1.132.048-3.345.048s-2.473-.008-3.345-.048c-.793-.037-1.224-.167-1.51-.28a2.518 2.518 0 0 1-.927-.604 2.518 2.518 0 0 1-.604-.927c-.113-.286-.243-.717-.28-1.51C1.448 10.473 1.44 10.213 1.44 8s.008-2.473.048-3.345c.037-.793.167-1.224.28-1.51a2.518 2.518 0 0 1 .604-.927 2.518 2.518 0 0 1 .927-.604c.286-.113.717-.243 1.51-.28C5.527 1.448 5.787 1.44 8 1.44z"/>
            <path d="M8 3.88a4.12 4.12 0 1 0 0 8.24 4.12 4.12 0 0 0 0-8.24zm0 6.79a2.67 2.67 0 1 1 0-5.34 2.67 2.67 0 0 1 0 5.34z"/>
            <circle cx="12.18" cy="3.82" r="0.92"/>
          </svg>
        </a> */}
      </p>
    </footer>
  );
}

export default Footer;
